// Mapeo de códigos de país a banderas
export const getCountryFlag = (countryCode) => {
  const flags = {
    // Países Latinoamericanos
    'MX': '🇲🇽', // México
    'AR': '🇦🇷', // Argentina
    'CO': '🇨🇴', // Colombia
    'PE': '🇵🇪', // Perú
    'CL': '🇨🇱', // Chile
    'VE': '🇻🇪', // Venezuela
    'EC': '🇪🇨', // Ecuador
    'BO': '🇧🇴', // Bolivia
    'PY': '🇵🇾', // Paraguay
    'UY': '🇺🇾', // Uruguay
    'BR': '🇧🇷', // Brasil
    'GT': '🇬🇹', // Guatemala
    'BZ': '🇧🇿', // Belice
    'CR': '🇨🇷', // Costa Rica
    'PA': '🇵🇦', // Panamá
    'HN': '🇭🇳', // Honduras
    'SV': '🇸🇻', // El Salvador
    'NI': '🇳🇮', // Nicaragua
    'CU': '🇨🇺', // Cuba
    'DO': '🇩🇴', // República Dominicana
    'PR': '🇵🇷', // Puerto Rico
    
    // Países Europeos
    'ES': '🇪🇸', // España
    'FR': '🇫🇷', // Francia
    'IT': '🇮🇹', // Italia
    'DE': '🇩🇪', // Alemania
    'GB': '🇬🇧', // Reino Unido
    'PT': '🇵🇹', // Portugal
    'NL': '🇳🇱', // Países Bajos (Holanda)
    'CH': '🇨🇭', // Suiza
    'AT': '🇦🇹', // Austria
    'BE': '🇧🇪', // Bélgica
    'IE': '🇮🇪', // Irlanda
    'GR': '🇬🇷', // Grecia
    'PL': '🇵🇱', // Polonia
    'CZ': '🇨🇿', // República Checa
    'HU': '🇭🇺', // Hungría
    'RO': '🇷🇴', // Rumania
    'BG': '🇧🇬', // Bulgaria
    'HR': '🇭🇷', // Croacia
    'SK': '🇸🇰', // Eslovaquia
    'SI': '🇸🇮', // Eslovenia
    
    // América del Norte
    'US': '🇺🇸', // Estados Unidos
    'CA': '🇨🇦', // Canadá
    
    // Otros países importantes
    'AU': '🇦🇺', // Australia
    'NZ': '🇳🇿', // Nueva Zelanda
    'ZA': '🇿🇦', // Sudáfrica
    'JP': '🇯🇵', // Japón
    'KR': '🇰🇷', // Corea del Sur
    'CN': '🇨🇳', // China
    'IN': '🇮🇳', // India
    'PH': '🇵🇭', // Filipinas
    'RU': '🇷🇺'  // Rusia
  };
  
  return flags[countryCode] || '🌍';
};

// Función para obtener nombre completo del país
export const getCountryName = (countryCode) => {
  const names = {
    // Países Latinoamericanos
    'MX': 'México',
    'AR': 'Argentina',
    'CO': 'Colombia',
    'PE': 'Perú',
    'CL': 'Chile',
    'VE': 'Venezuela',
    'EC': 'Ecuador',
    'BO': 'Bolivia',
    'PY': 'Paraguay',
    'UY': 'Uruguay',
    'BR': 'Brasil',
    'GT': 'Guatemala',
    'BZ': 'Belice',
    'CR': 'Costa Rica',
    'PA': 'Panamá',
    'HN': 'Honduras',
    'SV': 'El Salvador',
    'NI': 'Nicaragua',
    'CU': 'Cuba',
    'DO': 'República Dominicana',
    'PR': 'Puerto Rico',
    
    // Países Europeos
    'ES': 'España',
    'FR': 'Francia',
    'IT': 'Italia',
    'DE': 'Alemania',
    'GB': 'Reino Unido',
    'PT': 'Portugal',
    'NL': 'Países Bajos',
    'CH': 'Suiza',
    'AT': 'Austria',
    'BE': 'Bélgica',
    'IE': 'Irlanda',
    'GR': 'Grecia',
    'PL': 'Polonia',
    'CZ': 'República Checa',
    'HU': 'Hungría',
    'RO': 'Rumania',
    'BG': 'Bulgaria',
    'HR': 'Croacia',
    'SK': 'Eslovaquia',
    'SI': 'Eslovenia',
    
    // América del Norte
    'US': 'Estados Unidos',
    'CA': 'Canadá',
    
    // Otros países importantes
    'AU': 'Australia',
    'NZ': 'Nueva Zelanda',
    'ZA': 'Sudáfrica',
    'JP': 'Japón',
    'KR': 'Corea del Sur',
    'CN': 'China',
    'IN': 'India',
    'PH': 'Filipinas',
    'RU': 'Rusia'
  };
  
  return names[countryCode] || countryCode;
};

// Función para obtener lista de países organizados para el formulario
export const getCountriesForForm = () => {
  const countries = [
    // América Latina (ordenados alfabéticamente)
    { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: 'BZ', name: 'Belice', flag: '🇧🇿' },
    { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
    { code: 'BR', name: 'Brasil', flag: '🇧🇷' },
    { code: 'CL', name: 'Chile', flag: '🇨🇱' },
    { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
    { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
    { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
    { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    { code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
    { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
    { code: 'HN', name: 'Honduras', flag: '🇭🇳' },
    { code: 'MX', name: 'México', flag: '🇲🇽' },
    { code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
    { code: 'PA', name: 'Panamá', flag: '🇵🇦' },
    { code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
    { code: 'PE', name: 'Perú', flag: '🇵🇪' },
    { code: 'PR', name: 'Puerto Rico', flag: '🇵🇷' },
    { code: 'DO', name: 'República Dominicana', flag: '🇩🇴' },
    { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
    { code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
    
    // Europa (ordenados alfabéticamente)
    { code: 'DE', name: 'Alemania', flag: '🇩🇪' },
    { code: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: 'BE', name: 'Bélgica', flag: '🇧🇪' },
    { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
    { code: 'HR', name: 'Croacia', flag: '🇭🇷' },
    { code: 'SK', name: 'Eslovaquia', flag: '🇸🇰' },
    { code: 'SI', name: 'Eslovenia', flag: '🇸🇮' },
    { code: 'ES', name: 'España', flag: '🇪🇸' },
    { code: 'FR', name: 'Francia', flag: '🇫🇷' },
    { code: 'GR', name: 'Grecia', flag: '🇬🇷' },
    { code: 'HU', name: 'Hungría', flag: '🇭🇺' },
    { code: 'IE', name: 'Irlanda', flag: '🇮🇪' },
    { code: 'IT', name: 'Italia', flag: '🇮🇹' },
    { code: 'NL', name: 'Países Bajos', flag: '🇳🇱' },
    { code: 'PL', name: 'Polonia', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
    { code: 'GB', name: 'Reino Unido', flag: '🇬🇧' },
    { code: 'CZ', name: 'República Checa', flag: '🇨🇿' },
    { code: 'RO', name: 'Rumania', flag: '🇷🇴' },
    { code: 'CH', name: 'Suiza', flag: '🇨🇭' },
    
    // América del Norte
    { code: 'CA', name: 'Canadá', flag: '🇨🇦' },
    { code: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
    
    // Otros países importantes
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'CN', name: 'China', flag: '🇨🇳' },
    { code: 'KR', name: 'Corea del Sur', flag: '🇰🇷' },
    { code: 'PH', name: 'Filipinas', flag: '🇵🇭' },
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'JP', name: 'Japón', flag: '🇯🇵' },
    { code: 'NZ', name: 'Nueva Zelanda', flag: '🇳🇿' },
    { code: 'RU', name: 'Rusia', flag: '🇷🇺' },
    { code: 'ZA', name: 'Sudáfrica', flag: '🇿🇦' }
  ];
  
  return countries;
};